var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.upload($event)}}},[_c('input',{ref:"fileInput",attrs:{"type":"file"},on:{"change":_vm.onFileSelected}}),_vm._v(" "),_c('button',[_vm._v(" Submit")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d8a7d86","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Upload.vue
// module id = null
// module chunks = 